import { hookstate } from '@hookstate/core'

const globalTOSStore = hookstate({
});

export default globalTOSStore;